"use strict";

exports.__esModule = true;
exports.StackedBarChart = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _yAxis = require("../Axes/YAxis/yAxis");
var _constants = require("../constants");
var _TooltipContent = require("../Tooltip/TooltipContent");
var _recharts = require("recharts");
var _d3Scale = require("d3-scale");
var _legendStyle = require("../legendStyle");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var StackedBarChartContainer = _styledComponents["default"].div.withConfig({
  displayName: "StackedBarChart__StackedBarChartContainer",
  componentId: "sc-tg7x77-0"
})([""]);
var StackedBarChart = exports.StackedBarChart = function StackedBarChart(props) {
  var width = props.width,
    height = props.height,
    colors = props.colors,
    series = props.series,
    _props$tooltipProps = props.tooltipProps,
    tooltipProps = _props$tooltipProps === void 0 ? {} : _props$tooltipProps,
    _props$xAxisProps = props.xAxisProps,
    xAxisProps = _props$xAxisProps === void 0 ? {} : _props$xAxisProps,
    _props$yAxisProps = props.yAxisProps,
    yAxisProps = _props$yAxisProps === void 0 ? {} : _props$yAxisProps,
    _props$showGrid = props.showGrid,
    showGrid = _props$showGrid === void 0 ? true : _props$showGrid,
    _props$showChartToolt = props.showChartTooltip,
    showChartTooltip = _props$showChartToolt === void 0 ? true : _props$showChartToolt,
    _props$showLegend = props.showLegend,
    showLegend = _props$showLegend === void 0 ? true : _props$showLegend;
  var theme = _react["default"].useContext(_styledComponents.ThemeContext);
  var _useLegendHighlightEf = useLegendHighlightEffect(),
    highlightedDataKey = _useLegendHighlightEf.highlightedDataKey,
    handleLegendMouseEnter = _useLegendHighlightEf.handleLegendMouseEnter,
    handleLegendMouseLeave = _useLegendHighlightEf.handleLegendMouseLeave;
  var domain = ["dataMin", "dataMax"];
  var scale = (0, _d3Scale.scaleUtc)().domain(domain);
  var ticks = scale.ticks(10).map(function (v) {
    return v.valueOf();
  });
  var formatter = scale.tickFormat();
  return /*#__PURE__*/_react["default"].createElement(StackedBarChartContainer, {
    "data-testid": "StackedBarChart.container"
  }, /*#__PURE__*/_react["default"].createElement(_recharts.BarChart, {
    width: width,
    height: height,
    data: series,
    margin: {
      left: 0,
      right: 0
    }
  }, showGrid && (theme.uiModern ? /*#__PURE__*/_react["default"].createElement(_recharts.CartesianGrid, {
    vertical: false,
    stroke: theme.ChartGridColor
  }) : /*#__PURE__*/_react["default"].createElement(_recharts.CartesianGrid, {
    strokeDasharray: "3 3"
  })), /*#__PURE__*/_react["default"].createElement(_recharts.XAxis, _extends({
    tick: theme.uiModern ? {
      fontSize: 10.5,
      fill: theme.ChartAxisTextColor,
      fontFamily: theme.ChartFontFamilyMono
    } : {
      fontSize: theme.fontSizeXS,
      fill: theme.color
    },
    axisLine: !theme.uiModern,
    tickLine: !theme.uiModern,
    dataKey: "key",
    ticks: ticks,
    domain: domain,
    tickFormatter: function tickFormatter(timestamp) {
      return formatter(new Date(timestamp));
    }
  }, xAxisProps)), (0, _yAxis.yAxis)(Object.assign({}, yAxisProps, {
    theme: theme
  })), showChartTooltip && /*#__PURE__*/_react["default"].createElement(_recharts.Tooltip, {
    cursor: {
      fill: theme.TooltipCursorFillColor
    },
    content: /*#__PURE__*/_react["default"].createElement(_TooltipContent.TooltipContent, {
      xDataKey: "key",
      chartType: _constants.LINE_CHART,
      xValueFormatter: tooltipProps.xValueFormatter,
      yValueFormatter: tooltipProps.yValueFormatter
    })
  }), showLegend && /*#__PURE__*/_react["default"].createElement(_recharts.Legend, _extends({}, (0, _legendStyle.legendStyle)(theme, {
    iconType: "square",
    iconSize: 9
  }, {
    iconSize: 12
  }), {
    onMouseEnter: handleLegendMouseEnter,
    onMouseLeave: handleLegendMouseLeave,
    wrapperStyle: {
      fontSize: (0, _legendStyle.legendFontSize)(theme),
      padding: "5px 10px"
    }
  })), colors.map(function (color) {
    var opacity = 1;
    if (highlightedDataKey && highlightedDataKey !== color.key) {
      opacity = 0.4;
    }
    return /*#__PURE__*/_react["default"].createElement(_recharts.Bar, {
      key: color.key,
      className: "bar-stack bar-stack-" + color.key,
      fillOpacity: opacity,
      stackId: "alerts",
      dataKey: color.key,
      fill: color.color
    });
  })));
};
var useLegendHighlightEffect = function useLegendHighlightEffect() {
  var _useState = (0, _react.useState)(null),
    highlightedDataKey = _useState[0],
    setHighlightedDataKey = _useState[1];
  var handleLegendMouseEnter = function handleLegendMouseEnter(o) {
    var dataKey = o.dataKey;
    setHighlightedDataKey(dataKey);
  };
  var handleLegendMouseLeave = function handleLegendMouseLeave() {
    setHighlightedDataKey(null);
  };
  return {
    highlightedDataKey: highlightedDataKey,
    handleLegendMouseEnter: handleLegendMouseEnter,
    handleLegendMouseLeave: handleLegendMouseLeave
  };
};